import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText, Divider } from '@mui/material';
import { selectSx, menuSx } from './filterStyles';
import FilterField from './FilterField';

const MultiDropdown = ({ label, field, selected, options, onToggle, onSelectAll }) => {
  const allSelected  = options.length > 0 && selected.length === options.length;
  const someSelected = selected.length > 0 && !allSelected;

  const renderValue = (sel) => {
    if (sel.length === 0)               return <em style={{ color: '#546E7A', fontSize: 13 }}>All</em>;
    if (sel.length === options.length)  return <em style={{ color: '#4FC3F7', fontSize: 13 }}>All selected</em>;
    if (sel.length <= 2)                return sel.join(', ');
    return `${sel[0]}, ${sel[1]} +${sel.length - 2} more`;
  };

  return (
    <FilterField label={label} count={selected.length}>
      <Select
        multiple fullWidth size="small"
        value={selected}
        onChange={function() {}}
        renderValue={renderValue}
        displayEmpty
        sx={selectSx}
        MenuProps={menuSx}
      >
        <MenuItem dense onClick={() => onSelectAll(field, options)}
          sx={{ '&:hover': { backgroundColor: '#0D2A40' } }}>
          <Checkbox size="small" checked={allSelected} indeterminate={someSelected}
            sx={{ p: 0.5, color: '#1E3A5F', '&.Mui-checked': { color: '#4FC3F7' }, '&.MuiCheckbox-indeterminate': { color: '#FF9800' } }} />
          <ListItemText
            primary={allSelected ? 'Deselect All' : 'Select All'}
            primaryTypographyProps={{ fontSize: 12, fontWeight: 700, color: '#4FC3F7' }} />
        </MenuItem>

        <Divider sx={{ borderColor: '#1E3A5F', my: 0.5 }} />

        {options.length === 0 && (
          <MenuItem disabled sx={{ fontSize: 12, color: '#546E7A', fontStyle: 'italic' }}>No options</MenuItem>
        )}

        {options.map((opt) => (
          <MenuItem key={opt} dense value={opt} onClick={() => onToggle(field, opt)}
            sx={{ '&:hover': { backgroundColor: '#0D2A40' } }}>
            <Checkbox size="small" checked={selected.includes(opt)}
              sx={{ p: 0.5, color: '#1E3A5F', '&.Mui-checked': { color: '#4FC3F7' } }} />
            <ListItemText primary={opt} primaryTypographyProps={{ fontSize: 13 }} />
          </MenuItem>
        ))}
      </Select>
    </FilterField>
  );
};

export default MultiDropdown;